export const getEnvEndpoints = () => {
  const isUpgrade = Boolean(process.env.REACT_APP_SERVER_UPGRADE && process.env.REACT_APP_SERVER_UPGRADE === "1");
  if (isUpgrade) {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL_NEW || 'https://management-idbf.inexture.in',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2_NEW || 'https://management-idbf.inexture.in/es/',
      REACT_APP_ESUSERNAME: process.env.REACT_APP_ESUSERNAME_NEW,
      REACT_APP_ESPSW: process.env.REACT_APP_ESPSW_NEW,
      REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL: process.env.REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL_NEW || 'https://media.100procentlokaal.be/media/'
    }
  } else if (Boolean(process.env.REACT_APP_SERVER_UPGRADE && process.env.REACT_APP_SERVER_UPGRADE === "elastic")) {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL_NEW || 'https://management-idbf-stg.inexture.com',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2_NEW || 'https://management-idbf-stg.inexture.com/es/',
      REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL: process.env.REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL_NEW || 'https://media.100procentlokaal.be/media/'
    }
  } else {  
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL || 'https://management.100procentlokaal.be',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2 || 'https://management.100procentlokaal.be/es/',
      REACT_APP_ESUSERNAME: process.env.REACT_APP_ESUSERNAME,
      REACT_APP_ESPSW: process.env.REACT_APP_ESPSW,
      REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL: process.env.REACT_APP_DEVELOPMENT_IMAGE_THUMBNAIL_URL_NEW || 'https://media.100procentlokaal.be/media/'
    }
  }
};

//websites ENV URL constants 
const ENVIRONMENTS = {
  dev: {
    SERVER_UPGRADE: "dev",
    DOMAIN_URL: "migration.100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "migration.100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "migration.ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "migration.reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "migration.wijzig.100procentlokaal.be",
    CATALOGOUS_DOMAIN_URL: "migration.catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "migration.promonetwerk.be",
    MAVILLE_DOMAIN_URL:"migration.ma.ville-commune.be",
    MIJNSTADGEMEENTE_DOMAIN_URL:"migration.mijn.stad-gemeente.be",
    CITYMUNI_DOMAIN_URL:"migration.my.city-municipality.be",
    STADTGEMEINDE_DOMAIN_URL:"migration.meine.stadt-gemeinde.be"
  },
  staging: {
    SERVER_UPGRADE: "staging",
    DOMAIN_URL: "staging.100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "staging.100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "staging.ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "staging.reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "staging.wijzig.100procentlokaal.be",
    CATALOGOUS_DOMAIN_URL: "staging.catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "staging.promonetwerk.be",
    MAVILLE_DOMAIN_URL:"staging.ma.ville-commune.be",
    MIJNSTADGEMEENTE_DOMAIN_URL:"staging.mijn.stad-gemeente.be",
    CITYMUNI_DOMAIN_URL:"staging.my.city-municipality.be",
    STADTGEMEINDE_DOMAIN_URL:"staging.meine.stadt-gemeinde.be"
  },
  elastic: {
    SERVER_UPGRADE: "elastic",
    DOMAIN_URL: "elastic.100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "elastic.100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "elastic.ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "elastic.reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "elastic.wijzig.100procentlokaal.be",
    CATALOGOUS_URL: "elastic.catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "elastic.promonetwerk.be",
    MAVILLE_DOMAIN_URL:"elastic.ma.ville-commune.be",
    MIJNSTADGEMEENTE_DOMAIN_URL:"elastic.mijn.stad-gemeente.be",
    CITYMUNI_DOMAIN_URL:"elastic.my.city-municipality.be",
    STADTGEMEINDE_DOMAIN_URL:"elastic.meine.stadt-gemeinde.be"
  },
  production: {
    SERVER_UPGRADE: "production",
    DOMAIN_URL: "100procentlokaal.be",
    '100_POURCENT_DOMAIN_URL': "100pourcentlocale.be",
    ONDERNEMERSNETWERK_DOMAIN_URL: "ondernemersnetwerk.be",
    RESEAUENTREPRENEURS_DOMAIN_URL: "reseauentrepreneurs.be",
    WIJZIG_DOMAIN_URL: "wijzig.100procentlokaal.be",
    CATALOGOUS_DOMAIN_URL: "catalogusnetwerk.be",
    PROMONETWERK_DOMAIN_URL: "www.promonetwerk.be",
    MAVILLE_DOMAIN_URL:"ma.ville-commune.be",
    MIJNSTADGEMEENTE_DOMAIN_URL:"mijn.stad-gemeente.be",
    CITYMUNI_DOMAIN_URL:"my.city-municipality.be",
    STADTGEMEINDE_DOMAIN_URL:"meine.stadt-gemeinde.be"
  },
};

/**
 * Returns the environment config based on REACT_APP_SERVER_UPGRADE
 * Defaults to 'production' if not set or invalid
 */
export function getEnvironmentConfig() {
  const env = process.env.REACT_APP_SERVER_UPGRADE?.toLowerCase() || "production";
  return ENVIRONMENTS[env] || ENVIRONMENTS.production;
}
